var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',_vm._l((_vm.todos),function(todo,i){return _c('TodoItem',{attrs:{"todo":todo,"index":i},on:{"remove-todo":_vm.removeTodo}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }